/** What a form holds for the mail recipients, whatever the server answered. */
export const mailRecipientsToForm = (recipients) => ({
  userIds: recipients?.userIds || [],
  sectorHeads: !!recipients?.sectorHeads,
  requester: !!recipients?.requester,
  emails: recipients?.emails || [],
});
